<template>
    <div class>
      <div
      slot="header"
      class="clearfix"
      style="background-color: #f2f2f2; padding: 20px"
    >
      <span style="font-weight: 600; color: #000; line-height: 10px"
        >告警设置</span>
      <el-button type="success" plain @click="cancel" style="float: right; padding: 3px 0" >返回</el-button>

    </div>
          <el-form :model="form" ref="form" label-width="120px" style="width: 600px; margin-top: 20px;">
            <el-form-item label="设置名称" prop="name">
                <div style="margin-left: 50px;">{{form.name}}</div>
            </el-form-item>
            <el-form-item label="选择协议" prop="protocolName">
                <div style="margin-left: 50px;">{{form.protocolName}}</div>
            </el-form-item>
            <div v-for="(_item,index) in form.detailList" :key="index">
              <el-card
                  class="box-card" style="width:800px;"
                  :body-style="{ paddingLeft: '0px',marginTop:'0px', width:'800px'}"
                >
                <el-form-item label="告警项" prop="field">
                    <div style="margin-left: 50px;">{{_item.fieldCHS}}</div>
                </el-form-item>
                <el-form-item label="比较模式" prop="compareType">
                    <div style="margin-left: 50px;">{{_item.compareType=='1'?'过高':'过低'}}</div>
                </el-form-item>
                <el-form-item label="告警原因" prop="reason">
                    <div style="margin-left: 50px;">{{_item.reason}}</div>
                </el-form-item>
                  <el-form-item label="一级告警阈值">
                    <el-row >
                        <el-col :span="12">
                          <el-row>
                              <el-col :span="24">
                                  <div style="margin-left: 50px;">{{_item.oneThreshold}}</div>
                              </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="_item.oneAlarmNotice" label="是否告警"></el-checkbox>
                            <el-checkbox v-model="_item.oneSmsNotice" label="告警短信"></el-checkbox>
                        </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="二级告警阈值">
                    <el-row >
                        <el-col :span="12">
                          <el-row>
                              <el-col :span="24">
                                  <div style="margin-left: 50px;">{{_item.twoThreshold}}</div>
                              </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="_item.twoAlarmNotice" label="是否告警"></el-checkbox>
                            <el-checkbox v-model="_item.twoSmsNotice" label="告警短信"></el-checkbox>
                        </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="三级告警阈值">
                    <el-row >
                        <el-col :span="12">
                          <el-row>
                              <el-col :span="24">
                                  <div style="margin-left: 50px;">{{_item.threeThreshold}}</div>
                              </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="10">
                            <el-checkbox v-model="_item.threeAlarmNotice" label="是否告警"></el-checkbox>
                            <el-checkbox v-model="_item.threeSmsNotice" label="告警短信"></el-checkbox>
                        </el-col>
                    </el-row>
                  </el-form-item>
                </el-card>
            </div>
        </el-form>
        <div
          class="clearfix"
          style="background-color: #f2f2f2; padding: 20px;margin-top:30px;"
        >
          <span style="font-weight: 600; color: #000; line-height: 10px"
            >设备设置</span
          >
        </div>
        <div class>
          <el-form
            :model="form2"
            ref="form"
            label-width="150px"
            style="width: 800px; margin-top: 30px"
            class="device-form-wrap"
          >
            <el-form-item label="选择设备" style="width: 500px">
              <el-tree
                class="filter-tree"
                :data="datatree1"
                show-checkbox
                :props="defaultProps"
                default-expand-all
                node-key="id"
                :default-checked-keys="checkedNodes"
                ref="tree1"
              >
              </el-tree>
            </el-form-item>
          </el-form>
        </div>
    </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
const token = window.localStorage.getItem("token");
  export default {
    name: "alarmSettingsDetail",
    components: {},
    data() {
      return {
        defaultProps: {
            children: 'children',
            label: 'name',
        },
        id: "",
        tableData: [],
        datatree1:[],
        checkedNodes:[],
        form2: {},
        form:{
          name: "",
          protocolName: "",
          deviceIDs:"",
          detailList: [
          {
            fieldCHS: "",
            compareType: "",
            reason: "",
            oneThreshold: "",
            oneAlarmNotice: false,
            oneSmsNotice: false,
            twoThreshold: "",
            twoAlarmNotice: false,
            twoSmsNotice: false,
            threeThreshold: "",
            threeAlarmNotice: false,
            threeSmsNotice: false
          }]
        }
      };
    },
    computed: {},
    methods: {
      cancel() {
        this.$router.go(-1);
      }
    },
    mounted() {
      this.$nextTick(function() {
        let tmpDetail = this.$route.query.data;
        //从字符串转boolean
        tmpDetail.detailList.forEach(element => {
          element.oneAlarmNotice = element.oneAlarmNotice === 'true';
          element.oneSmsNotice = element.oneSmsNotice === 'true';
          element.twoAlarmNotice = element.twoAlarmNotice === 'true';
          element.twoSmsNotice = element.twoSmsNotice === 'true';
          element.threeAlarmNotice = element.threeAlarmNotice === 'true';
          element.threeSmsNotice = element.threeSmsNotice === 'true';
        });
        this.form = {
          name: tmpDetail.name,
          protocolName: tmpDetail.protocolName,
          deviceIDs: tmpDetail.deviceIDs,
          detailList: tmpDetail.detailList
        }
        this.checkedNodes = tmpDetail.deviceIDs.split(',');
      });
    },
    beforeCreate() {
      this.$store.dispatch("form/handle", {
        url: "/battery/tree/projectDevice",
        data: {},
        method: "get",
        callback: (resp) => {
          this.datatree1 = resp;
        },
      });
    }, //生命周期 - 创建之前
    beforeMount() {

    }, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>

<style lang="less" src="" scoped>
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/alarmSettings/alarmSettingsDetail.vue